module.exports = __webpack_public_path__ + "img/1_3.6daaeb9f.jpg";